<template>
  <div>
    <!--  -->
    <div class="w-full delivery-note" :id="`Modalprint_${item._id}`" :ref="`Modalprint_${item._id}`">
      <!--  -->
      <div class="w-full border-2 border-solid border-black">
        <!--  -->
        <div class="w-full h-20 flex items-center border-0 border-b-2 border-solid border-black">
          <!--  -->
          <div class="w-sixth h-full">
            <!--  -->
            <div class="w-full h-full flex items-center justify-center border-0 border-r-2 border-solid border-black">
              <!--  -->
              <img class="h-12 object-contain" alt="..." :src="rushLivImage"/>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->
  
          <!--  -->
          <div class="w-quarter h-full flex items-center justify-center">
            <!--  -->
            <div class="w-full h-full flex flex-col gap-3 items-center justify-center px-2">
              <!--  -->
              <span class="text-xl font-bold">{{ $moment(item.date).format('yyyy-MM-DD') }}</span>
              <!--  -->
              <span class="text-xl font-bold" v-if="item.echange && item.echange.date">ECHANGE</span>
              <!--  -->
              <span class="text-xl font-bold" v-else>STOCK</span>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->
  
        <!--  -->
        <div class="w-full flex">
          <!--  -->
          <div class="w-sixth flex flex-col">
            <!--  -->
            <div class="w-full h-14 flex items-center justify-center border-0 border-b-2 border-r-2 border-solid border-black">
              <!--  -->
              <div class="w-full h-full flex flex-col justify-center px-2">
                <!--  -->
                <div class="flex items-center">
                  <span class="text-lg capitalize">{{$t('seller')}} :
                    <img class="h-5 object-contain" alt="..." :src="storeinoShipImage"/>
                  </span>
                </div>
                <!--  -->
                <div class="flex items-center">
                  <span class="text-lg capitalize">{{$t('phone')}} :
                    <span class="font-semibold">0661382142</span>
                  </span>
                </div>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <div class="flex flex-col gap-2 px-4 mt-4">
              <!--  -->
              <span class="text-lg font-semibold capitalize" v-if="item.order.customer.fullName">
                <span class="bg-black text-white">{{ $t('customer') }} :</span>
                <span> {{item.order.customer.fullName}}</span>
              </span>
              <!--  -->
              <span class="text-lg capitalize" v-if="item.order.customer.phone">
                <span class="bg-black text-white font-semibold">{{ $t('phone') }} :</span>
                <span class="font-medium"> {{item.order.customer.phone}}</span>
              </span>
              <!--  -->
              <span class="text-lg font-semibold capitalize" v-if="item.order.customer.city">
                <span class="bg-black text-white">{{ $t('city') }} :</span>
                <span> {{item.order.customer.city}}</span>
              </span>
              <!--  -->
            </div>
          </div>

          <!--  -->
          <div class="w-quarter flex items-center justify-center">
            <!--  -->
            <qrcode :style="{width: '156px', height: '156px'}" :value="item.trackingNumber" tag="img" :options="{ height: 100, fontoptions: 'bold', fontSize: 30 }"></qrcode>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->

        <!--  -->
        <div class="flex flex-col gap-2 px-4 mt-2">
          <!--  -->
          <span class="text-lg font-semibold capitalize" v-if="item.address">
            <span class="bg-black text-white">{{ $t('address') }} :</span>
            <span> {{item.address}}</span>
          </span>
          <!--  -->
          <span class="text-lg font-semibold capitalize">
            <span class="bg-black text-white">{{ $t('comment') }} :</span>
            <span>{{ formattedComment }}</span>
          </span>
          <!--  -->
          <span class="text-lg font-semibold capitalize">
            <span class="bg-black text-white">{{ $t('merchandise') }} :</span>
            <span>{{ formattedMerchandise }}</span>
          </span>
          <!--  -->
          <span class="text-lg font-semibold capitalize" v-if="item.hub">
            <span class="bg-black text-white">{{ $t('hub') }} :</span>
            <span> {{item.hub}}</span>
          </span>
          <!--  -->
        </div>
        <!--  -->
  
        <!--  -->
        <div class="mx-2 mt-8">
          <table class="w-full border-collapse">
            <!--  -->
            <thead>
              <!--  -->
              <tr>
                <!--  -->
                <th class="text-lg font-semibold text-center bg-black px-2 border-2 border-solid border-black py-2">
                  <!--  -->
                  <span class="text-white">{{ item.shippingZone ? item.shippingZone : 'None' }}</span>
                  <!--  -->
                </th>
                <!--  -->

                <!--  -->
                <th class="px-2 text-center border-2 border-solid border-black py-2">
                  <!--  -->
                  <span class="text-lg font-bold">{{ `${$t('crbt')} : ${item.order.totalPrice.toFixed(0)} ${ idWharhouse.currency || 'DH'}`}}</span>
                  <!--  -->
                </th>
                <!--  -->
              </tr>
              <!--  -->
            </thead>
            <!--  -->
  
            <!--  -->
            <tbody>
              <tr>
                <td class="px-2 text-center border-2 border-solid border-black py-1">
                  <span class="text-base font-medium whitespace-no-wrap">
                    {{ $t( item.orderObjet.openpackage !== undefined ? item.orderObjet.openpackage ? 'package_authorized': 'package_not_authorized' :item.authorize_package ? 'package_authorized' :'package_not_authorized') }}
                  </span>
                </td>
                <td class="px-2 text-center border-2 border-solid border-black py-1">
                  <span class="text-base font-medium whitespace-no-wrap">
                    {{ $t('colis_normal') }}
                  </span>
                </td>
              </tr>
            </tbody>
            <!--  -->
          </table>
        </div>
        <!--  -->

        <!--  -->
        <div class="text-center px-4 py-2" v-if="item.trackingNumber">
          <!--  -->
          <span class="text-2xl font-bold">{{ item.trackingNumber }}</span>
          <!--  -->
        </div>
        <!--  -->
      </div>
      <!--  -->
    </div>
    <!--  -->

    <!--  -->
    <div :id="'ModalprintList_' + item._id" class="shipp-print">
      <!--  -->
      <tr>
        <!--  -->
        <td style="padding-left:3px;padding-right:3px" class="text-center whitespace-no-wrap text-black">
          <!--  -->
          <span style="font-size: 0.60rem;line-height: 0.70rem;" class="text-xs text-black" >{{ item.order.id }}</span>
          <!--  -->
        </td>
        <!--  -->
        <td style="padding-left:3px;padding-right:3px" class="text-center whitespace-no-wrap text-black">
          <!--  -->
          <span style="font-size: 0.60rem;line-height: 0.70rem;" class="text-xs overflow-visible whitespace-no-wrap text-black" >{{ item.trackingNumber }}</span>
          <!--  -->
        </td>
        <!--  -->
        <td style="padding-left:3px;padding-right:3px" class="text-center whitespace-no-wrap text-black">
          <!--  -->
          <span style="font-size: 0.60rem;line-height: 0.70rem;" class="text-xs text-black" >{{ item.order.customer.city }}</span>
          <!--  -->
        </td>
        <!--  -->
        <td style="padding-left:3px;padding-right:3px" class="text-center whitespace-no-wrap text-black">
          <!--  -->
          <span style="font-size: 0.60rem;line-height: 0.70rem;" class="text-xs text-black" >{{ item.seller.company || item.seller.fullName }}</span>
          <!--  -->
        </td>
        <!--  -->
        <td style="padding-left:3px;padding-right:3px" class="text-center whitespace-no-wrap text-black">
          <!--  -->
          <span style="font-size: 0.60rem;line-height: 0.70rem;" class="text-xs text-black" >{{ QuantityTotalProductOrder(item) }}</span>
          <!--  -->
        </td>
        <!--  -->
        <td style="padding-left:3px;padding-right:3px" class="text-center whitespace-no-wrap text-black">
          <!--  -->
          <span style="font-size: 0.60rem;line-height: 0.70rem;" class="text-xs text-black" >{{ item.order.totalPrice.toFixed(2) }}
            <!--  -->
            <sup v-if="idWharhouse">{{ idWharhouse.currency || 'DH' }}</sup></span>
          <!--  -->
        </td>
        <!--  -->
        <td style="padding-left:3px;padding-right:3px" class="barcode-img text-center whitespace-no-wrap text-black">
          <!--  -->
          <vue-barcode :value="item.trackingNumber" tag="img"></vue-barcode>
          <!--  -->
        </td>
        <!--  -->
      </tr>
      <!--  -->
    </div>
    <!--  -->
  </div>
  <!--  -->
</template>
<!--  -->

<script>
import css from '@/assets/style.css';
import tableProduct from '@/views/shippings/tableProducts.vue';
export default {
  name:"PrintModal",
  components: {
    tableProduct,
  },
  data() {
    return {
      dropdownPopoverShow: false,
      cssLink: css,
      storeinoShipImage: 'https://storeno.b-cdn.net/stores/9-2024/1725621466720.webp',
      rushLivImage: 'https://storeno.b-cdn.net/stores/9-2024/1725620943138.png',
      usernameTeleconsul: '',
      expediteur: '',
    };
  },
  props: {
    config: { required: true, type: Object },
    item: { default: [] },
    idWharhouse: { type: Object },
    currency: { type: String },
    feesShipp: { type: Object },
  },
  computed: {
    formattedDate() {
      return this.$moment(this.item.date).format('yyyy-MM-DD HH:mm');
    },
    formattedComment() {
      return this.formatOrderDetails((name, quantity) => ` SKU: ${name}, QTE: ${quantity}`);
    },
    formattedMerchandise() {
      return this.formatOrderDetails((name, quantity) => ` ${name} (${quantity})`);
    }
  },
  methods: {
    formatOrderDetails(formatFunction) {
      return this.item.order.details
        .map(el => {
          const name = el.variante ? el.variante.name : el.product.name;
          return formatFunction(name, el.quantity);
        })
        .join(' | ');
    },
    exceptNameProduct(text) {
      if (text && text.length > 60) text = text.substring(0, 60) + '...';
      return text;
    },
    QuantityTotalProductOrder(data) {
      var qte = 0;
      for (let i in data.order.details) {
        qte += data.order.details[i].quantity;
      }
      return qte;
    },
    async getStatusByName(name) {
      const result = await this.$server.get('status', { name: name });
      return result.content._id;
    },
  },
};
</script>
